import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock, renderSlot as _renderSlot, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass([
          'absolute w-full text-zbr-gray-700 text-[12.8px] whitespace-nowrap text-clip overflow-hidden',
          'top-[-16px] left-0 text-[10px]'
        ])
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "w-full flex items-baseline"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "text-[12.8px] text-zbr-black-900 whitespace-nowrap label"
}
const _hoisted_6 = {
  key: 1,
  class: "text-[12.8px] text-zbr-black-900 whitespace-nowrap label"
}
const _hoisted_7 = {
  key: 1,
  class: "text-wrapper w-full flex items-baseline justify-between mr-2"
}
const _hoisted_8 = {
  key: 0,
  class: "placeholder text-zbr-gray-700 text-[12.8px] label"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-[12.8px] text-zbr-black-900 whitespace-nowrap label"
}
const _hoisted_11 = {
  key: 2,
  class: "label text-[12.8px] text-zbr-black-900 whitespace-nowrap label"
}
const _hoisted_12 = { class: "h-full flex items-center justify-center" }
const _hoisted_13 = {
  key: 0,
  class: "h-[18px] w-px bg-zbr-gray-300 mx-3"
}
const _hoisted_14 = { class: "absolute top-0 left-0 w-full h-full flex items-center justify-center backdrop-blur-sm" }
const _hoisted_15 = {
  key: 0,
  class: "relative h-full text-center py-10"
}
const _hoisted_16 = {
  key: 1,
  class: "h-full"
}
const _hoisted_17 = {
  key: 2,
  class: "h-full overflow-y-auto"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "w-full flex items-center justify-between py-0.5 leading-6 text-left min-h-[26px]" }

import IconCaret from '@/components/icons/IconCaret.vue';
import IconClose from '@/components/icons/IconClose.vue';
import Loading from 'vue3-loading-overlay/dist/index';

import { BaseSelectDropdownItem, BaseSelectDropdownItemState } from '@/utils/types/index';

import { onClickOutside } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { computed, ref, watch, nextTick } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectDropdown',
  props: {
    modelValue: {},
    placeholder: { default: '' },
    width: { default: '' },
    items: {},
    className: { default: '' },
    triggerClassName: { default: '' },
    isRounded: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    isLoadingInit: { type: Boolean, default: false },
    divider: { type: Boolean, default: false },
    customIcon: { type: Boolean, default: false },
    isObjValue: { type: Boolean, default: false },
    objKey: { default: 'key' },
    isRelative: { type: Boolean, default: false },
    isSingleSelected: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    topPlaceHolder: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "on-select-item", "on-clear"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





__expose({
  reset,
  setSelectedItemState,
});

const { t, locale } = useI18n();

const itemsOptionState = ref([] as BaseSelectDropdownItemState[]);
const selectedItems = ref([] as BaseSelectDropdownItemState[]);
const isOpen = ref(false);
const dropdownRef = ref(null);

// Computed
const getSelectedLabelText = computed(() => {
  if (selectedItems.value.length === 0) {
    return '';
  }
  return selectedItems.value.slice().map((item) => t(item.label)).join();
});
const getSelectedValues = computed(() => {
  if (selectedItems.value.length === 0) {
    return [];
  }
  return selectedItems.value.slice().map((item) => item.value);
});

// Watchers
watch(() => props.items, () => {
  setItemsOptionState();
});
watch(() => props.modelValue, () => {
  if (props.modelValue.length === 0) {
    reset();
  }
});
watch(locale, () => {
  nextTick(() => {
    // Set option item status
    setItemsOptionState();

    // Set selectedItems state
    initSetSelectedItemState();
  });
});

// Methods
function initSetSelectedItemState() {
  if (itemsOptionState.value.length === 0) {
    return;
  }
  selectedItems.value = itemsOptionState.value.slice()
    .filter((item) => item.selected);
}
function setItemsOptionState() {
  if (props.items.length === 0) {
    itemsOptionState.value = [];
    return;
  }
  itemsOptionState.value = props.items.slice().map((item) => {
    const stringSelectedValues = props.modelValue.map((v) => v + '');
    const isSelected = stringSelectedValues.find((v: string) => {
      return v === (item.value + '');
    });
    if (props.modelValue.length === 0) {
      return {
        value: item.value,
        label: item.label,
        selected: !!isSelected,
      };
    } else {
      return {
        value: item.value,
        label: item.label,
        selected: stringSelectedValues.includes(item.value + ''),
      };
    }
  });
}
function toggleDropdown() {
  isOpen.value = !isOpen.value;
}
function hideDropdown() {
  isOpen.value = false;
}
function onSelectItem(item: BaseSelectDropdownItemState) {
  if (props.isSingleSelected) {
    itemsOptionState.value = props.items.slice().map((optionItem) => {
      if (optionItem.value === item.value) {
        return {
          value: optionItem.value,
          label: optionItem.label,
          selected: !item.selected,
        };
      } else {
        return {
          value: optionItem.value,
          label: optionItem.label,
          selected: false,
        };
      }
    });
    const foundedItem = itemsOptionState.value.find((optionItem) => optionItem.value === item.value);
    if (foundedItem && foundedItem.selected) {
      selectedItems.value = [foundedItem];
    } else {
      selectedItems.value = [];
    }
    emit('update:modelValue', getSelectedValues.value);
    emit('on-select-item');
    hideDropdown();
    return;
  }
  item.selected = !item.selected;
  let stringSelectedValues: string[] = [];
  if (props.isObjValue) {
    stringSelectedValues = props.modelValue.map((objV) => objV[props.objKey] + '');
  } else {
    stringSelectedValues = props.modelValue.map((v) => v + '');
  }

  const isDouble = stringSelectedValues.find((v) => {
    return v === (item.value + '');
  });

  if (item.selected) {
    if(isDouble) {
      return;
    }
    selectedItems.value = [
      ...selectedItems.value,
      item,
    ];
    emit('update:modelValue', getSelectedValues.value);
    emit('on-select-item');
    return;
  }

  let index = 0;
  if (props.isObjValue) {
    index = selectedItems.value.findIndex((selectItem) => (selectItem.value[props.objKey] + '') === (item.value[props.objKey] + ''));
  } else {
    index = selectedItems.value.findIndex((selectItem) => (selectItem.value + '') === (item.value + ''));
  }
  selectedItems.value.splice(index, 1);
  emit('update:modelValue', getSelectedValues.value);
  emit('on-select-item');
}
function reset() {
  selectedItems.value = [];
  // emit('update:modelValue', []);
}
function setSelectedItemState(item: BaseSelectDropdownItemState) {
  if (itemsOptionState.value.length === 0) {
    return;
  }
  onSelectItem(item);
}

/**
 * On start
 * */

// Listen to on click outside
onClickOutside(dropdownRef, () => {
  hideDropdown();
});

// Set option item status
setItemsOptionState();

// Set selectedItems state
initSetSelectedItemState();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "dropdownRef",
    ref: dropdownRef,
    class: _normalizeClass([
      _ctx.className,
      _ctx.disabled ? 'pointer-events-none opacity-50' : null,
    ])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'dropdown-trigger dropdown',
        isOpen.value
          ? _ctx.isRelative
            ? 'is-open h-auto'
            : 'is-open h-10'
          : _ctx.isRelative
            ? 'h-11 hover:shadow-border-gray-300'
            : 'h-10 hover:shadow-border-gray-300',
        _ctx.triggerClassName
      ])
    }, [
      (_ctx.placeholder.length && _ctx.topPlaceHolder && selectedItems.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.placeholder) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: _normalizeClass(["dropdown-toggle top-0 left-0 w-full bg-white px-2 flex items-center justify-between z-30 text-clip overflow-hidden", [
          _ctx.isRounded ? 'rounded' : null,
          isOpen.value
            ? 'after:absolute after:w-select-dropdown-container after:h-0.5 after:bg-zbr-gray-300 after:bottom-px after:left-1/2 after:transfrom after:-translate-x-1/2 after:z-[41]'
            : null,
          _ctx.isRelative
            ? 'relative h-10'
            : 'absolute h-full',
        ]]),
        onClick: toggleDropdown
      }, [
        (_ctx.topPlaceHolder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.placeholder.length)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass([
              'absolute text-zbr-gray-700 text-[12.8px] whitespace-nowrap label',
              selectedItems.value.length ? 'top-[-16px] left-0 text-[10px]' : 'top-1/2 transform -translate-y-1/2'
            ])
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.placeholder) + " ", 1),
                    (_ctx.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, "*"))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (selectedItems.value.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (selectedItems.value.length > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(selectedItems.value.length) + " " + _toDisplayString(_ctx.$t('ITEMS')), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(getSelectedLabelText.value), 1))
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.placeholder.length && selectedItems.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.placeholder) + " ", 1),
                    (_ctx.required)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (selectedItems.value.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(selectedItems.value.length) + " " + _toDisplayString(_ctx.$t('ITEMS')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(getSelectedLabelText.value), 1))
            ])),
        _createElementVNode("div", _hoisted_12, [
          (_ctx.divider)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition duration-150",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition duration-150",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (isOpen.value)
                  ? (_openBlock(), _createBlock(IconClose, {
                      key: 0,
                      "class-stroke": "stroke-zbr-gray-700",
                      size: 10
                    }))
                  : (_ctx.customIcon)
                    ? _renderSlot(_ctx.$slots, "custom-icon", {
                        key: 1,
                        class: "custom-icon"
                      })
                    : (_openBlock(), _createBlock(IconCaret, {
                        key: 2,
                        class: "caret-icon",
                        size: 24
                      }))
              ]),
              _: 3
            })
          ])
        ])
      ], 2),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass([
          'left-0 w-full px-2 pb-2 max-h-[300px] overflow-y-auto bg-white shadow-border-gray-300-no-top duration-500 z-[41]',
          _ctx.isRounded ? 'rounded-b' : null,
          _ctx.isRelative ? 'relative' : 'absolute top-full',
          _ctx.isLoading || _ctx.isLoadingInit ? 'min-h-[34px]' : null,
        ])
          }, [
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition ease-in duration 100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(Loading), {
                    color: "var(--color-primary)",
                    "is-full-page": false,
                    width: 30,
                    height: 30,
                    active: ""
                  })
                ], 512), [
                  [_vShow, _ctx.isLoading]
                ])
              ]),
              _: 1
            }),
            _createVNode(_Transition, {
              mode: "out-in",
              "enter-active-class": "transition ease-out duration-100",
              "enter-from-class": "opacity-0",
              "enter-to-class": "opacity-100",
              "leave-active-class": "transition ease-in duration 100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoadingInit && isOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_unref(Loading), {
                        color: "var(--color-primary)",
                        "is-full-page": false,
                        width: 30,
                        height: 30,
                        active: ""
                      })
                    ]))
                  : (itemsOptionState.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t('NO-RESULT')), 1))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemsOptionState.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: `${item.label}-${index}`,
                            class: _normalizeClass([
                'group border-b border-zbr-gray-200 hover:bg-zbr-primary-50',
                index === itemsOptionState.value.length - 1 ? 'border-b-0' : null
              ]),
                            onClick: ($event: any) => (onSelectItem(item))
                          }, [
                            _createElementVNode("button", _hoisted_19, [
                              _createElementVNode("span", {
                                class: _normalizeClass([
                    'font-roboto-condensed text-[12.8px]',
                    getSelectedValues.value.includes(item.value) ? 'text-zbr-primary' : 'text-zbr-black-900'
                  ])
                              }, _toDisplayString(_ctx.$t(item.label)), 3),
                              (getSelectedValues.value.includes(item.value))
                                ? (_openBlock(), _createBlock(IconClose, {
                                    key: 0,
                                    "class-stroke": "stroke-zbr-primary",
                                    size: 8
                                  }))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, _hoisted_18))
                        }), 128))
                      ]))
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})